import {Component, h} from "preact";
import styles from './style.module.scss';
import {Image, Product, Variant} from "../../models/product";
import ProductImage from "../product-image";
import {connect} from "redux-zero/preact";
import actions from "../../store/actions";
import {productService} from "../../services/product-service";
import {withDeviceIndicator} from "../../hoc/withDeviceIndicator";
import {imageService} from "../../services/image-service";
import {NY_Tracker, TrackingEvent} from "../../services/tracking-service";
import {i18nService} from "../../services/i18n-service";
import {navigationService} from "../../services/navigation-service";


interface Props {
  product: Product;
  selected: Variant;
  isMobile?: boolean;
}

interface State {
  hideColorImage: boolean;
}

class Colors extends Component<Props, any> {

  state: State = {
    hideColorImage: false
  };

  handleClick(variant: Variant) {
    window.scrollTo({left: 0, top: 0, behavior: 'smooth'});
    const imageContainer = document.querySelector('.image-scroll-snap-container');
    if (imageContainer) {
      imageContainer.scrollTo({left: 0, top: 0, behavior: 'smooth'});
    }

    const detailContainer = document.querySelector('.detail-scroll-snap-container');
    if (detailContainer) {
      detailContainer.scrollTo({left: 0, top: 0, behavior: 'smooth'});
    }

    let event = {
      label: `${variant.productId} - ${variant.id}`,
      action: 'selectColor',
      category: 'Products',
      isSale: variant.sale ? '1' : '0',
      imageType: (variant.images.find(i => i.position === 0) as Image)?.type
    };

    NY_Tracker.trackClick(event as TrackingEvent);
    navigationService.showDetailView(variant.productId, variant.id);
  }

  onImageLoadingError() {
    this.setState({hideColorImage: true});
  }

  render() {
    if (!this.props.product && !this.props.selected) {
      return null;
    }
    const selected = this.props.selected;

    if (this.props.product.variants.length > 0) {
      if (this.props.isMobile) {
        return (
            <div class={`${styles['colors-container']} ${styles.mobile}`}>
              <div class={styles['headline']}>{i18nService.translate('detail_view_product_colors')}</div>
              <div id={'detail-colors-scroll-container'} class={styles['slider']}>
                {this.props.product.variants.map(v => {
                  const variant = new Variant(v);
                  return (
                      <div class={`${styles['color-container']}`}>
                        <div class={`${styles['color']} ${variant.productId === selected.productId && variant.id === selected.id ? styles.selected : ''}`}
                             onClick={() => this.handleClick(variant)}>
                          <div class={styles['image-container']}>
                            <ProductImage scrollContainer={'#detail-colors-scroll-container'} image={this._findCutout(variant.images)} displayType={'preview'}
                                          alt={`${i18nService.translate(productService.getTranslationKey(this.props.product))} | ${variant.getColorTranslation()} | NEW YORKER`}
                                          title={`${i18nService.translate(productService.getTranslationKey(this.props.product))} | ${variant.getColorTranslation()} | NEW YORKER`}/>
                          </div>
                        </div>
                      </div>
                  )
                })}
              </div>
            </div>
        )
      }

      return (
          <div class={`${styles['colors-container']} ${styles.desktop}`}>
            <div class={styles['colors']}>
              {this.props.product.variants.map(v => {
                const variant = new Variant(v);
                const thumbnailUrl = imageService.findThumbnail(variant.images);
                const backgroundColor = `rgb(${variant.red}, ${variant.green}, ${variant.blue})`;
                const colorName = variant.getColorTranslation();
                return (
                    <div class={`${styles['color-container']} ${variant.productId === selected.productId && variant.id === selected.id ? styles.selected : ''}`} title={colorName}>
                      <div class={`${styles['color']}`}
                           style={`background-color: ${backgroundColor}`}
                           onClick={() => this.handleClick(variant)}>
                        {thumbnailUrl && !this.state.hideColorImage &&
                        <img class={styles['thumbnail-img']} src={thumbnailUrl} alt={colorName} onError={this.onImageLoadingError.bind(this)}/>}
                      </div>
                    </div>
                )
              })}
            </div>
            <div class={styles['color-name']}>{this.props.selected.getColorTranslation()}</div>
          </div>
      )

    }
  }

  _findCutout(images: Image[]): Image {
    const image = images.find(image => image.type === 'CUTOUT');
    return image ? image : images [0];
  }
}

export default connect(null, actions)(withDeviceIndicator(Colors))
